import React, { createContext, useContext, useState, useEffect } from 'react';

const SiteSettingsContext = createContext({});

export const useSiteSettings = () => useContext(SiteSettingsContext);

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings`);
        const data = await response.json();
        
        // Convert array to object for easier access
        const settingsObj = {};
        (data.settings || []).forEach(s => {
          settingsObj[s.setting_key] = s.value;
        });
        setSettings(settingsObj);
      } catch (err) {
        console.error('Error loading site settings:', err);
        // Use defaults
        setSettings({
          hero_title: 'TACTICAL',
          hero_subtitle: 'OUTDOOR WEAR',
          hero_description: 'Zorlu koşullar için tasarlandı. Premium malzemeler, dayanıklı yapı, profesyonel performans.',
          brand_name: 'VAV WEAR',
          brand_slogan: 'TACTICAL & OUTDOOR',
        });
      } finally {
        setLoading(false);
      }
    };
    
    fetchSettings();
  }, []);

  // Helper function to get setting with default
  const getSetting = (key, defaultValue = '') => {
    return settings[key] || defaultValue;
  };

  return (
    <SiteSettingsContext.Provider value={{ settings, loading, getSetting }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export default SiteSettingsContext;
